import { useCallback } from 'react';
import { useUserContext } from '../context';
import {
    findHotel,
    formatSubscriptionExpiry,
    getSubscriptionDaysLeft,
    isSubscriptionActive,
    isSubscriptionExpiringSoon,
    notifySubscriptionBlocked
} from '../utils/hotelSubscription';

// Subscription state for a hotel. Defaults to the hotel selected in the top nav.
// Derived on every render from the context's hotel list, so it follows reloads and hotel switches.
export function useSubscriptionGuard(hotelId) {
    const { assignments, defaultHotel } = useUserContext();
    const hotel = findHotel(assignments?.hotels, hotelId || defaultHotel);

    // Not loaded yet: stay editable so the UI doesn't flash a locked state.
    const canEdit = !hotel || isSubscriptionActive(hotel);

    const ensureCanEdit = useCallback(() => {
        if (canEdit) {
            return true;
        }
        notifySubscriptionBlocked();
        return false;
    }, [canEdit]);

    return {
        hotel,
        canEdit,
        ensureCanEdit,
        daysLeft: hotel ? getSubscriptionDaysLeft(hotel) : null,
        isExpiringSoon: !!hotel && isSubscriptionExpiringSoon(hotel),
        expiryText: hotel ? formatSubscriptionExpiry(hotel) : ""
    };
}
